import * as React from 'react';

export const CrossThin = (
  <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path d='M4.5 19.5L19.5 4.5' stroke='#000000' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
    <path d='M4.5 4.5L19.5 19.5' stroke='#000000' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
  </svg>
);
